module.exports = __webpack_public_path__ + "static/media/heart.615b8432.png";